import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  collectionSnapshots,
  Firestore,
} from '@angular/fire/firestore';
import { IssueClass } from '@sleipai/sleip-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class IssueService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  loadIssues(): Observable<IssueClass[]> {
    return collectionSnapshots(
      collection(this.firestore, `/common/issues/issues/`)
    ).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((snap) => {
        return snap.map((i) => {
          const data = i.data() as any;
          const id = i.id;
          return new IssueClass({ id, ...data });
        });
      })
    );
  }
}
